import { PORTFOLIO } from '../data';
import Magnetic from './Magnetic';
import './Hero.css';

function Hero({ onNavigate }) {
  return (
    <section id="home" className="hero">
      <p className="hero__label">
        <span style={{ '--d': '0.1s' }}>Hi, I'm</span>
      </p>
      <h1 className="hero__name">
        {PORTFOLIO.name.split(' ').map((word, i) => (
          <span className="hero__word" key={word}>
            <span style={{ '--d': `${0.25 + i * 0.09}s` }}>{word}</span>
          </span>
        ))}
      </h1>
      <p className="hero__title">
        <span style={{ '--d': '0.65s' }}>{PORTFOLIO.title}</span>
      </p>
      <div className="hero__actions" style={{ '--d': '0.9s' }}>
        <Magnetic>
          <button className="btn btn--primary" onClick={() => onNavigate('contact')}>
            Let's connect
          </button>
        </Magnetic>
        <Magnetic>
          <a
            href="/resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--ghost"
          >
            Resume
          </a>
        </Magnetic>
      </div>
      <p className="hero__aside" style={{ '--d': '1.05s' }}>
        <a
          href={PORTFOLIO.links.probe}
          target="_blank"
          rel="noopener noreferrer"
          className="hero__game"
        >
          or play <span className="hero__game-name">Probe</span>, my daily game ↗
        </a>
      </p>
      <div className="hero__scroll-hint" aria-hidden="true" style={{ '--d': '1.4s' }}>
        <span className="hero__scroll-line" />
      </div>
    </section>
  );
}

export default Hero;
